declare var swal: any;
import { Component, ViewEncapsulation, Input, ChangeDetectionStrategy, OnInit, ViewChild } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalRef, NgbDateStruct, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
//import { FileUploader } from 'ng2-file-upload/ng2-file-upload';
import { ApiResponseModel } from '../../../models/api_response_model';
import { ApiRequestModel } from '../../../models/api_request_model';
import { SpinnerService } from '../../../services/spinner.service';
import { AppData } from '../../../models/appdata';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

//import { DBOperation } from '../../../../../enums/enum';
import { ActorEmploymentPreferencesRequest, ActorContactInfoRequest, EmergencyContactInfoRequest, SaveEmergencyContactInfoRequest } from '../../../models/profileinfo/profileinfo.model';
import { HCPService } from '../../../services/hcp.service';


import * as alertFunctions from '../../../../shared/data/sweet-alerts';
import { NGXToastrService } from '../../../../shared/services/toastr.service';
import { ServiceConsultantMapController, ServiceDetailsByCodeController, ServiceDetailsByCodeRequest, ServiceBranchMapByServiceCodeController, ServiceBranchMapByServiceCodeRequest, SaveIahOrderStatusRequest, SaveIahOrderItemStatusRequest, MaterialBatchInaStoreController, MaterialBatchInaStoreRequest } from '../../../models/actor/actor';
import { ServiceConsultantMapRequest } from '../../../models/actor/actor';
import { ActorService } from '../../../services/actor.service';
import { CustomCodeTypeRequest_, CustomCodeValuesController_ } from '../../../models/master/mastermodel';
import { FDService } from '../../../services/fd.service';
import { ConsultantMapPipe } from '../../../pipes/actors/actorIdentity.pipes';
import { parse } from 'querystring';
import { Time } from '@angular/common';

@Component({
  selector: 'ngbatchdetail',
    templateUrl: './batchdetail.modal.html',
    styleUrls: ['./batchdetail.modal.scss']
})

export class NgbBatchDetailModal implements OnInit {
  @ViewChild('f') IdentitiesForm: NgForm;
    @Input() ModelType: string;
    @Input() CustomerName: string;
    @Input() OrderCode: number;
    @Input() ConsumptionGroup: string;
    @Input() StroreLocation: string;
    @Input() MaterialName: string;
    @Input() ItemCode: number;
    @Input() StoreCode: number;
    @Input() BatchCode: number;
    @Input() Address: string;
    @Input() OrderDate: Date;
    @Input() CreUser: string;
    @Input() Status: string;
    @Input() Date: Date;
    @Input() ScheduleDate: Date;
    @Input() AssignedNmae: string;
    @Input() ScheduleTime: Time;
    @Input() OrderStatus: string;
    @Input() Comments: string;
    @Input() ServiceName: string;
    @Input() BatchName: string;
    @Input() Quantity: number;
   // @Input() ItemCode: number;
    SelectedFromDate: NgbDateStruct;
    TodayDate = new Date();
    public ActorCode: number = 0;
    public FacilityCode: number;
    SelectedDate: NgbDateStruct;
  //@Input() IsShowDetail: boolean = false;
  //@Input() CurrentActorEditEmergencyInfoRequest: EmergencyContactInfoRequest;
  //@Input() ServiceCode: number;
    @Input() CurrentSaveIahOrderItemStatusRequest: SaveIahOrderItemStatusRequest;
  searchTitle: string;
  public ApiResData: ApiResponseModel;
    CurrentSaveIahOrderStatusRequest: SaveIahOrderStatusRequest;
    //CurrentSaveIahOrderItemStatusRequest: SaveIahOrderItemStatusRequest;
  public isRequesting: boolean = false;
  public ShowService: boolean = true;
  //public IsSelected: boolean;
    public length: number;
    CurrentMaterialBatchInaStoreRequest: MaterialBatchInaStoreRequest;
  CurrentMaterialBatchInaStoreController: MaterialBatchInaStoreController[];
  CurrentMaterialBatchInaStoreController2: MaterialBatchInaStoreController;
    StoreItems() {

        this.CurrentMaterialBatchInaStoreRequest = new MaterialBatchInaStoreRequest();
        //this.pdata2 = this.ServicesByCategoryCodeController;
        this.CurrentMaterialBatchInaStoreRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.CurrentMaterialBatchInaStoreRequest.ConditionalOperator = 20;
        this.CurrentMaterialBatchInaStoreRequest.StoreCode = this.StoreCode;
        this.CurrentMaterialBatchInaStoreRequest.MaterialBatchCode = this.BatchCode;
        this.CurrentMaterialBatchInaStoreRequest.MaterialCode = this.ItemCode;
        //this.CurrentConsumptionGroupItemsRequest = new Array<ServicesByCategoryCodeController>();

        this.GetMaterialBatchInaStoreController();

    }
    GetMaterialBatchInaStoreController() {
        this.StartRefreshing();
        this.actorservice.GetMaterialBatchInaStoreController(this.CurrentMaterialBatchInaStoreRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                //alert(this.ApiResData.ErrorData);
                if (!this.ApiResData.hasError) {

                  this.CurrentMaterialBatchInaStoreController = this.ApiResData.Result;
                  this.CurrentMaterialBatchInaStoreController2 = this.ApiResData.Result;
                    this.length = this.CurrentMaterialBatchInaStoreController.length;
                    this.LoadFilter();
                    //this.pdata = this.CurrentServicesByCategoryCodeController;

                    this.stopRefreshing();

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );

    }
  IsQtyNotAvlbl(l: any) {
    // alert(l.AvailableQuantity);
    var AvailableQuantity = l.AvailableQuantity;
    var Quantity = l.Quantity;
    // alert(RequiredQty);
    //  alert(AvailableQty);

    if (Quantity > AvailableQuantity) {
      alertFunctions.AlertParam("Required Quantity is greater than Available Quantity" + "...!");

    }
    else
      return;
  }
  calculateDiff(dateSent) {
    let currentDate = new Date();
    dateSent = new Date(dateSent);
    var d = Math.floor((Date.UTC(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate()) - Date.UTC(dateSent.getFullYear(), dateSent.getMonth(), dateSent.getDate())) / (1000 * 60 * 60 * 24));
    //alert(d);
    return d;
  }
  IsNotExpired(l: any): boolean {
    if (this.calculateDiff(l.ExpiryDate) > 0)
      return false; // go ahead and cancel
    else
      return true;

  }
  ExpiryDt(): boolean {
    var expirydate = new Date(this.CurrentMaterialBatchInaStoreController2.ExpiryDate);//.getDate();
    var today = new Date();//.getDate();
    if (expirydate.getDate() <= today.getDate() &&
      expirydate.getMonth() <= today.getMonth() &&
      expirydate.getFullYear() <= today.getFullYear()
    )
      return true; // go ahead and cancel
    else
      return false;
  }
    LoadFilter() {
        this.CurrentMaterialBatchInaStoreController.forEach((v, i, d) => {
            if (v.BatchNo == this.BatchName) {
                v.Quantity = this.Quantity;
            }
        });
    }
  constructor(public activeModal: NgbActiveModal, private loaderService: SpinnerService,
    private actorservice: ActorService, private fdservice: FDService, private filter: ConsultantMapPipe,
    private router: Router, private route: ActivatedRoute, private hcpservice: HCPService,
      private tosterservice: NGXToastrService, private parserFormatter: NgbDateParserFormatter) { }
    ngOnInit() {
        this.StoreItems();
      this.FacilityCode = AppData.Instance().SelectedBranchCode;
    this.ShowService = false;
      this.CurrentSaveIahOrderStatusRequest = new SaveIahOrderStatusRequest();
     // this.CurrentSaveIahOrderItemStatusRequest = new SaveIahOrderItemStatusRequest();
      this.CurrentSaveIahOrderStatusRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
      //this.CurrentSaveIahOrderItemStatusRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
      this.SelectedFromDate = { year: this.TodayDate.getFullYear(), month: this.TodayDate.getMonth() + 1, day: this.TodayDate.getDate() };

    this.LoadRegistries();
      if (this.Date != null) {
          var SValidFrom = new Date(this.Date);
          if (SValidFrom.getFullYear() > 1900) {
              console.log('this.UpdateDate >1990');
              this.SelectedDate = {

                  year: SValidFrom.getFullYear(),
                  month: SValidFrom.getMonth() + 1,
                  day: SValidFrom.getDate()
              }
          }
      }

  }




  LoadRegistries() {
    this.StartRefreshing();



    //this.GetBranchMap();


  }



  //onSubmit() {

  //  this.StartRefreshing();
  //  //alert(this.CurrentActorEmploymentPreferencesRequest.ReasonForAccommodation);
  //  this.CurrentActorEditEmergencyInfoRequest.ConditionalOperator = 20;
  //  this.hcpservice.SaveEmergencyContactInfo(this.CurrentActorEditEmergencyInfoRequest)
  //    .subscribe((result) => {
  //      this.ApiResData = result;
  //      if (!this.ApiResData.hasError) {

  //        if (this.ApiResData.Result > 0) {
  //          this.ShowService = false;
  //          //alertFunctions.AlertParam('Saved Successfully.....!');
  //          this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');

  //          this.activeModal.close();

  //          this.stopRefreshing();
  //        }
  //        else {
  //          alertFunctions.AlertParam("Invalid Operation...!");
  //          this.activeModal.close();

  //          this.stopRefreshing();

  //        }

  //      }
  //      else {
  //        this.stopRefreshing();
  //        if (this.ApiResData.ErrorData != "") {

  //          alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
  //          this.activeModal.close();


  //        }
  //        else {
  //          alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
  //          this.activeModal.close();
  //        }
  //      }

  //    },


  //      (error) => {

  //        if (error == "401 - Unauthorized") {
  //          alertFunctions.AlertParamEr(error);
  //          this.activeModal.close();
  //          this.stopRefreshing();



  //        }
  //        else {
  //          alertFunctions.AlertParamEr(error);
  //          this.activeModal.close();
  //          this.stopRefreshing();
  //        }
  //      }
  //    );

  //}
    onAssignedToActorCodesurgeon(event: any) {

        if (event != null) {
            //    if (this.CurrentSaveCounsellingPlanRequest.BranchCode > 0) {
            this.CurrentSaveIahOrderItemStatusRequest.AssignedToName = event;
            //this.CurrentSaveIahOrderItemStatusRequest.ProviderCode = event;
            // console.log('event--_>' + event);
            //   }
        }

    }

    onSubmitOrder() {
        


        this.CurrentSaveIahOrderStatusRequest.UserName = AppData.Instance().UserLoginDetails.DisplayName;
        this.CurrentSaveIahOrderStatusRequest.ConditionalOperator = 10;
        this.CurrentSaveIahOrderStatusRequest.IahOrderCode = this.OrderCode;
        this.CurrentSaveIahOrderStatusRequest.Timestamp = new Date();

        this.actorservice.SaveIahOrderStatus(this.CurrentSaveIahOrderStatusRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    if (this.ApiResData.Result > 0) {
                        //this.GetActorEducationInfoController();
                        //this.GetResourceIdentificationByDateInfoController();
                        // alertFunctions.AlertParam('Saved Successfully.....!');
                        this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
                        //this.isvisible = false;
                        this.activeModal.close();

                        this.stopRefreshing();
                    }
                    else {
                        alertFunctions.AlertParam("Invalid Operation...!");


                        this.stopRefreshing();

                    }

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);



                    }
                    else {
                        this.stopRefreshing();
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);

                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);

                        this.stopRefreshing();
                    }
                }
            );

    }
    onSubmitProvider() {



        this.CurrentSaveIahOrderItemStatusRequest.UserName = AppData.Instance().UserLoginDetails.DisplayName;
        this.CurrentSaveIahOrderItemStatusRequest.ConditionalOperator = 10;
        this.CurrentSaveIahOrderItemStatusRequest.IahOrderCode = this.OrderCode;
        this.CurrentSaveIahOrderItemStatusRequest.IahOrderCode = this.OrderCode;
        this.CurrentSaveIahOrderItemStatusRequest.Timestamp = new Date();
        this.CurrentSaveIahOrderItemStatusRequest.IahOrderItemCode = this.ItemCode;
        this.actorservice.SaveIahOrderItemStatus(this.CurrentSaveIahOrderItemStatusRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    if (this.ApiResData.Result > 0) {
                        //this.GetActorEducationInfoController();
                        //this.GetResourceIdentificationByDateInfoController();
                        // alertFunctions.AlertParam('Saved Successfully.....!');
                        this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
                        //this.isvisible = false;
                       // this.activeModal.close();

                        this.stopRefreshing();
                    }
                    else {
                        alertFunctions.AlertParam("Invalid Operation...!");


                        this.stopRefreshing();

                    }

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);



                    }
                    else {
                        this.stopRefreshing();
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);

                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);

                        this.stopRefreshing();
                    }
                }
            );

    }
    onSubmitSchedule() {



        this.CurrentSaveIahOrderItemStatusRequest.UserName = AppData.Instance().UserLoginDetails.DisplayName;
        this.CurrentSaveIahOrderItemStatusRequest.ConditionalOperator = 20;
        this.CurrentSaveIahOrderItemStatusRequest.IahOrderCode = this.OrderCode;
        this.CurrentSaveIahOrderItemStatusRequest.Timestamp = new Date(this.parserFormatter.format(this.SelectedDate));
        this.CurrentSaveIahOrderItemStatusRequest.IahOrderItemCode = this.ItemCode;
        this.actorservice.SaveIahOrderItemStatus(this.CurrentSaveIahOrderItemStatusRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    if (this.ApiResData.Result > 0) {
                        //this.GetActorEducationInfoController();
                        //this.GetResourceIdentificationByDateInfoController();
                        // alertFunctions.AlertParam('Saved Successfully.....!');
                        this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
                        //this.isvisible = false;
                      //  this.activeModal.close();

                        this.stopRefreshing();
                    }
                    else {
                        alertFunctions.AlertParam("Invalid Operation...!");


                        this.stopRefreshing();

                    }

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);



                    }
                    else {
                        this.stopRefreshing();
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);

                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);

                        this.stopRefreshing();
                    }
                }
            );

    }

    onSubmitStatus() {



        this.CurrentSaveIahOrderItemStatusRequest.UserName = AppData.Instance().UserLoginDetails.DisplayName;
        this.CurrentSaveIahOrderItemStatusRequest.ConditionalOperator = 30;
        this.CurrentSaveIahOrderItemStatusRequest.IahOrderCode = this.OrderCode;
        this.CurrentSaveIahOrderItemStatusRequest.Timestamp = new Date(this.parserFormatter.format(this.SelectedDate));
        this.CurrentSaveIahOrderItemStatusRequest.IahOrderItemCode = this.ItemCode;
        this.actorservice.SaveIahOrderItemStatus(this.CurrentSaveIahOrderItemStatusRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    if (this.ApiResData.Result > 0) {
                        //this.GetActorEducationInfoController();
                        //this.GetResourceIdentificationByDateInfoController();
                        // alertFunctions.AlertParam('Saved Successfully.....!');
                        this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
                        //this.isvisible = false;
                        this.activeModal.close();

                        this.stopRefreshing();
                    }
                    else {
                        alertFunctions.AlertParam("Invalid Operation...!");


                        this.stopRefreshing();

                    }

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);



                    }
                    else {
                        this.stopRefreshing();
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);

                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);

                        this.stopRefreshing();
                    }
                }
            );

    }


  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }





}
